import { useTheme } from '@/context/ThemeContext';

export default function Footer() {
  const { isDark } = useTheme();

  return (
    <footer
      className={`py-12 px-6 transition-colors duration-500 ${
        isDark ? 'bg-[#0A1219] border-t border-white/5' : 'bg-[#EEF3F8] border-t border-gray-200'
      }`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo + Description */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12">
            <img
              src="https://public.readdy.ai/ai/img_res/b0ae5da2-6cec-4d8b-8125-4fb963572c2f.png"
              alt="Vilaris AI Logo"
              className="object-contain opacity-90"
              style={{ width: '90px', height: '90px' }}
            />
            <p className={`text-sm max-w-md text-center md:text-left leading-relaxed transition-colors duration-500 ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
              Vilaris AI builds intelligent operational systems that help businesses scale with precision and clarity.
            </p>
          </div>

          {/* Navigation Links */}
          <nav className="flex items-center gap-8">
            {['Home', 'Services', 'Industries', 'Case Studies', 'Contact'].map((item) => (
              <a
                key={item}
                href={item === 'Home' ? '/' : `#${item.toLowerCase().replace(' ', '-')}`}
                className={`transition-colors text-sm font-medium cursor-pointer ${
                  isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-[#0D1B2A]'
                }`}
              >
                {item}
              </a>
            ))}
          </nav>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {['ri-linkedin-fill', 'ri-twitter-x-fill', 'ri-mail-fill'].map((icon) => (
              <a
                key={icon}
                href="#"
                className={`w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer group ${
                  isDark ? 'bg-white/5 hover:bg-[#14B8A6]/20' : 'bg-white hover:bg-[#14B8A6]/10 border border-gray-200'
                }`}
              >
                <i className={`${icon} text-base text-gray-400 group-hover:text-[#14B8A6] transition-colors`} />
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className={`mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 transition-colors duration-500 ${
            isDark ? 'border-t border-white/5' : 'border-t border-gray-200'
          }`}
        >
          <p className={`text-xs font-medium transition-colors duration-500 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
            © 2025 Vilaris AI. All rights reserved.
          </p>
          <div className="flex items-center gap-8">
            {['Privacy Policy', 'Terms of Service'].map((item) => (
              <a
                key={item}
                href="#"
                className={`transition-colors text-xs font-medium cursor-pointer ${
                  isDark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-700'
                }`}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
